import * as Factory from 'factory.ts'
import faker from 'faker'

import { type APIApplication } from '../../models'

export const APIApplicationMock = Factory.Sync.makeFactory<APIApplication>({
  description: Factory.each(() => faker.lorem.words(4)),
  client_id: Factory.each(() => faker.random.uuid()),
})

export const APIApplicationCreateMock =
  Factory.Sync.makeFactory<APIApplication>({
    description: Factory.each(() => faker.lorem.words(4)),
    client_id: Factory.each(() => faker.random.uuid()),
    client_secret: Factory.each(() => faker.random.uuid()),
  })
